/* eslint-disable @typescript-eslint/no-explicit-any */

var LIST_THEME_KEY = 'lists';

export { LIST_THEME_KEY };
//# sourceMappingURL=types.esm.js.map
